import { Component, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomRadioButtonComponent } from '../Utility/custom-radio-button/custom-radio-button.component';
import { CustomMultiButtonComponent } from '../Utility/custom-multi-button/custom-multi-button.component';
import { AppointmentPickerComponent } from '../appointment-picker/appointment-picker.component';
import { SignupServiceService } from './signup-service.service';
import { AppointmentPickerPropertiesService } from '../appointment-picker-properties.service';
import { Question } from './question';

@Component({
    selector: 'app-signup',
    imports: [
    FormsModule,
    // CustomRadioButtonComponent,
    // CustomMultiButtonComponent,
    AppointmentPickerComponent,
    CommonModule,
],
    templateUrl: './signup.component.html',
    styleUrl: './signup.component.scss'
})
export class SignupComponent {
  public today = new Date()
  public taxDay: Date
  public signupDay: Date
  currentYear: number
  taxYear: number
  timeToSignup: string
  successMessage = ""
  questions: string[] = []
  requiredFields = [
      'resident',
      'OldReturn',
      'Amendment',
      'householdIncome',
      'crypto',
      'selfEmployment',
      'email',
      'firstName',
      'lastName',
      'bestTimeToCall',
      'language', 
      // 'translator',
      // 'uploadDocuments',
    ]
  // crypto = ''
  submitting = false
  formErrors: string[] = []
  formErrorsHeader = ''
  showFormErrors = false
  data : Record<string, any> = {
    appttype: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    reminderType: '',
    bestTimeToCall: '',
    city: '',
    appointmentType: '',
    resident: '',
    OldReturn: '',
    Amendment: '',
    householdIncome: '',
    busninessIncome: '',
    busninessEmployees: '',
    uploadDocuments: '',
    householdPeople: 1,
    dependents: 0,
    selfEmployment: '',
    eitc: '',
    age: '',
    disability: '',
    crypto: '',
    marketplace: '',
    language: '',
    otherLanguage: '',
    translator: '',
    veteran: '',
    raceEthnicity: {},
    otherRaceEthnicity: '',
  }

  languageButtons = [
    {label: 'English', value: 'English'},
    {label: 'Spanish', value: 'Spanish'},
    {label: 'Other', value: 'Other'},
  ]

  countries = [ 
    { 'name': 'China', 'appointmentType': 'china' },
    { 'name': 'India', 'appointmentType': 'india' },
    { 'name': 'Armenia', 'appointmentType': 'treaty' },
    { 'name': 'Azerbaijan', 'appointmentType': 'treaty' },
    { 'name': 'Bangladesh', 'appointmentType': 'treaty' },
    { 'name': 'Belarus', 'appointmentType': 'treaty' },
    { 'name': 'Canada', 'appointmentType': 'treaty' },
    { 'name': 'Cyprus', 'appointmentType': 'treaty' },
    { 'name': 'Czech Republic', 'appointmentType': 'treaty' },
    { 'name': 'Egypt', 'appointmentType': 'treaty' },
    { 'name': 'France', 'appointmentType': 'treaty' },
    { 'name': 'Georgia', 'appointmentType': 'treaty' },
    { 'name': 'Germany', 'appointmentType': 'treaty' },
    { 'name': 'Iceland', 'appointmentType': 'treaty' },
    { 'name': 'Indonesia', 'appointmentType': 'treaty' },
    { 'name': 'Israel', 'appointmentType': 'treaty' },
    { 'name': 'Kazakhstan', 'appointmentType': 'treaty' },
    { 'name': 'Kyrgyzstan', 'appointmentType': 'treaty' },
    { 'name': 'Latvia', 'appointmentType': 'treaty' },
    { 'name': 'Lithuania', 'appointmentType': 'treaty' },
    { 'name': 'Moldova', 'appointmentType': 'treaty' },
    { 'name': 'Morocco', 'appointmentType': 'treaty' },
    { 'name': 'Netherlands', 'appointmentType': 'treaty' },
    { 'name': 'Norway', 'appointmentType': 'treaty' },
    { 'name': 'Pakistan', 'appointmentType': 'treaty' },
    { 'name': 'Philippines', 'appointmentType': 'treaty' },
    { 'name': 'Poland', 'appointmentType': 'treaty' },
    { 'name': 'Portugal', 'appointmentType': 'treaty' },
    { 'name': 'Romania', 'appointmentType': 'treaty' },
    { 'name': 'Russia', 'appointmentType': 'treaty' },
    { 'name': 'Slovak Republic', 'appointmentType': 'treaty' },
    { 'name': 'Slovenia', 'appointmentType': 'treaty' },
    { 'name': 'South Korea', 'appointmentType': 'treaty' },
    { 'name': 'Spain', 'appointmentType': 'treaty' },
    { 'name': 'Tajikistan', 'appointmentType': 'treaty' },
    { 'name': 'Thailand', 'appointmentType': 'treaty' },
    { 'name': 'Trinidad and Tobago', 'appointmentType': 'treaty' },
    { 'name': 'Tunisia', 'appointmentType': 'treaty' },
    { 'name': 'Turkmenistan', 'appointmentType': 'treaty' },
    { 'name': 'Ukraine', 'appointmentType': 'treaty' },
    { 'name': 'Uzbekistan', 'appointmentType': 'treaty' },
    { 'name': 'Venezuela', 'appointmentType': 'treaty' },
    { 'name': 'Other', 'appointmentType': 'non-treaty' }
  ]

  racesEthnicities = [
      {label: 'Black or African American', value: 'Black or African American'},
      {label: 'Hispanic or Latino/a', value: 'Hispanic or Latino/a'},
      {label: 'White', value: 'White'},
      {label: 'Asian', value: 'Asian'},
      {label: 'Native American or Alaska Native', value: 'Native American or Alaska Native'},
      {label: 'Native Hawaiian or Pacific Islander', value: 'Native Hawaiian or Pacific Islander'},
      {label: 'Multiracial', value: 'Multiracial'},
      {label: 'Other', value: 'Other'},
    ]

  currentStep = 1
  currentStepName = 'resident'
  nextStepDisabled = false
  maxSteps = document.querySelectorAll("#steps_wrapper .steps .step").length
  invalidFields: Record<any, any> = {}
  isFormValid = false
  submitTimeout: ReturnType<typeof setTimeout> | undefined;
  // iOS doesn't like smooth scrollTo on this form when the prev/next button is pushed - thinks it's an accidental scroll or something...
  scrollBehavior: ScrollBehavior = /iPad|iPhone|iPod/.test(navigator.userAgent) ? 'instant' : 'smooth' 
  resendToken = ''
  resendTokenSent = false
  showDemographicFields = false

  ngOnInit() {
    console.info("need to validate 'other' fields")
    var self = this 
    setTimeout(function(){
      self.maxSteps = document.querySelectorAll("#steps_wrapper .steps .step").length
      // mark as inert so can't accidentally tab over
      document.querySelectorAll(".step").forEach(el => {el.setAttribute('inert', '')})
      document.querySelector(".step.active")?.removeAttribute('inert');
    }, 250)

    window.addEventListener('resize', function(event) {
      // make sure our step is still in view
      const e = document.querySelector<HTMLElement>(`:nth-child(${self.currentStep} of .step`);
      if (e) 
        document.querySelector('.steps')?.scrollTo({left: e?.offsetLeft, behavior: self.scrollBehavior})
    });

    // intentionally defaulting reminders to both
    this.data['reminderType'] = 'both'


    // this.data['appttype'] = 'inperson'
    // this.data['firstName'] = 'Alex'
    // this.data['lastName'] = 'Trebek'
    // this.data['email'] = 'jrice@unl.edu'
    // this.data['phone'] = '4025226653'
    // this.data['bestTimeToCall'] = 'What is whenever'
    // this.data['city'] = 'Lincoln'
    // this.data['resident'] = 'Yes'
    // this.data['OldReturn'] = 'No'
    // this.data['Amendment'] = 'No'
    // this.data['householdIncome'] = 'No'
    // this.data['selfEmployment'] = 'No'
    // this.data['busninessIncome'] = ''
    // this.data['reminderType'] = 'email'
    // this.data['busninessEmployees'] = ''
    // this.data['uploadDocuments'] = ''
    // this.data['householdPeople'] = '1'
    // this.data['dependents'] = 'No'
    // this.data['eitc'] = ''
    // this.data['age'] = ''
    // this.data['crypto'] = 'No'
    // this.data['language'] = 'English'
    // this.data['translator'] = 'No'
    // this.data['marketplace'] = 'No'


    // // force to a specific step for testing
    // setTimeout(function() {
    //   self.currentStep = 9
    //   self.nextStep()
    // }, 550)

    this.validateRequiredFields()

    // setTimeout(() => {
    //   const isValid = self.validateRequiredFields();
    //   console.log("ERRORS TEST 1")
    //   if (isValid == false) {
    //     self.formErrorsHeader = "Please fix the following errors and then try again:";
    //     self.formErrors.push('Error 1')
    //     self.formErrors.push('Error 2')
    //     console.log("ERRORS test2")
    //     self.showFormErrors = true
    //   }
    // }, 3000)

    setTimeout(() => {
      var self = this;
      const stepsContainer = document.querySelector('.steps');

      stepsContainer?.addEventListener('scroll', (e) => {
        // if .steps tries to scroll vertically, NOPE!
        // fixes tab and label clicking issues that make .steps scroll up, breaking the form
        // only each .step should scroll as necessary 
        if (stepsContainer.scrollTop !== 0) {
          stepsContainer.scrollTop = 0;
          console.log("!!!!caught steps scroll")
          // let's scroll to the focused target in .step.active instead
          const focusedElement = (document.querySelector('.step.active :focus') as HTMLElement)
          if (focusedElement) {
            console.log("!!!!caught steps scroll - scrolling to :focus")
            document.querySelector(".step.active")?.scrollTo({ top: focusedElement?.offsetTop, behavior: self.scrollBehavior});
          }
        }
        
      });
    }, 500)
    
    
  }

  constructor(private signupServiceService: SignupServiceService, private appointmentPickerProperties: AppointmentPickerPropertiesService) {
    this.currentYear = this.today.getFullYear()
    // the +1 technically breaks the form and it displays past the desired end date
    // but we want to show the getyourrefund.org info and contact for in-person appts for now
    this.taxDay =  new Date(`${this.currentYear}-04-18`) // april 18th

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('testform'))
      this.signupDay =  new Date(`${this.currentYear}-01-08`)
    else
      this.signupDay =  new Date(`${this.currentYear}-01-15`)
    this.taxYear = this.currentYear - 1
    this.timeToSignup = this.signupDay.toDateString()
  }

  downloadUrl(url: string) {
    let fileLink = document.createElement('a');
    fileLink.href = url
    fileLink.setAttribute('download', 'false')
    fileLink.click()
    // const iframe = document.createElement('iframe');
    // iframe.style.display = 'none';
    // document.body.appendChild(iframe);
    
    // // Set the source of the iframe to the PDF file URL
    // iframe.src = url;
    
    // // Remove the iframe once the download is complete
    // setTimeout(() => {
    //   document.body.removeChild(iframe);
    // }, 1000); // adjust the timeout value as needed
  }

  downloadForm14446() {
    const fileUrl = '/server/download/downloadForm14446VirtualAppt.php';
    this.downloadUrl(fileUrl)
  }

  downloadForm4868() {
    const fileUrl = '/server/download/downloadForm4868.php';
    this.downloadUrl(fileUrl)
  }

  studentCountryChanged(event: any) {
    console.log(event.target.value)
    // if (country) {
    //   $scope.sharedProperties.appointmentType = country.appointmentType;
    // }
    // $scope.updateAppointmentType();
  }
  
  storeAppointments(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    if (this.submitting) return;
    this.submitting = true

    this.formErrors = []
    this.showFormErrors = false
    this.formErrorsHeader = ''
    
    const isValid = this.validateRequiredFields();

    if (isValid == false) {
      this.formErrorsHeader = "Please make sure all required fields have been filled and try again.";
      this.showFormErrors = true
      this.submitting = false
      return
    }

    // The country question has to give the appointmentType instead of the entire country object
    const countryQuestionDatabaseId = "6";

    // turn racesEthnicities in to csv
    var racesEthnicities = '';
    for (let [raceEthnicity, val] of Object.entries(this.data['raceEthnicity'])) {
      if (raceEthnicity == 'otherRaceEthnicity')
        racesEthnicities += this.data['raceEthnicity']['otherRaceEthnicity']+","
      else if (val)
        racesEthnicities += raceEthnicity+","
    }
    racesEthnicities = racesEthnicities.replace(/,\s*$/, "")
  
    

    var self = this
    clearTimeout(this.submitTimeout)
    console.log("creating Timeout")
    this.submitTimeout = setTimeout(function() {
        const data = {
            "action": "storeAppointment",
            "firstName": self.data['firstName'],
            "lastName": self.data['lastName'],
            "email": self.data['email'],
            "phone": self.data['phone'].replace(/\D/g, ""),
            "reminderType": self.data['reminderType'],
            "bestTimeToCall": self.data['bestTimeToCall'],
            "language": self.data['language'],
            "questions": {
                age: self.data['age'],
                Amendment: self.data['Amendment'],
                cryptoAction: self.data['crypto'],
                dates: self.data['dates'],
                dependents: self.data['dependents'],
                eitc: self.data['eitc'],
                householdIncome: self.data['householdIncome'],
                householdPeople: self.data['householdPeople'],
                language: self.data['otherLanguage'] ? 'Yes' : 'No', //self.data['translator'],
                translator: self.data['otherLanguage'] ? 'Yes' : 'No',
                marketplace: self.data['marketplace'],
                otherLanguage: self.data['otherLanguage'],
                OldReturn: self.data['OldReturn'],
                raceEthnicity: racesEthnicities, //self.data['raceEthnicity'],

                resident: self.data['resident'],
                selfEmployment: self.data['selfEmployment'],
                busninessEmployees: self.data['selfEmployment'] == 'Yes' ? self.data['busninessEmployees'] : '',
                busninessIncome: self.data['selfEmployment'] == 'Yes' ? self.data['busninessIncome'] : '',
              },
            "appointmentTimeId": self.appointmentPickerProperties.selectedTime,
            // "siteId": sharedProperties.selectedSite
          };
      console.log("Timeout called", data)
        self.signupServiceService.storeAppointments($.param(data)).subscribe({
          next: (response: any) => {
            console.log('Success!', response);
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            self.successMessage = response.message;
            // self.submitting = false
          },
          error: (error) => {
            self.submitting = false
            console.log("!!!!Submit error#1", error.status, error)
            if (error.status == 422) {
              self.formErrorsHeader = "Please fix the following errors and try again:";
              self.showFormErrors = true
              for (let e in error.error.errors)
                if (e == 'resendToken') {
                  self.resendToken = error.error.errors[e][0];
                }
                else  {
                  self.formErrors.push(error.error.errors[e][0])
                }
            }
            else {
              self.formErrorsHeader = "Sorry, a server error occurred. Please try again shortly, or reload the page and submit the form again. We apologize for any inconvenience. ";
              self.formErrorsHeader += ` (${error.status})`;
              self.showFormErrors = true
            }
            
          }
        });
      }, 250)
    
    return false
  }


  validate() {
    const hasEmptyFields = this.validateRequiredFields();

    this.invalidFields = {};

    if (this.data['resident'] != 'Yes') 
      this.invalidFields['resident'] = true
    if (this.data['OldReturn'] != 'No')
      this.invalidFields['OldReturn'] = true
    if (this.data['Amendment'] != 'No')
      this.invalidFields['Amendment'] = true

    if (this.data['selfEmployment'] == 'Yes') {
      if (this.data['busninessIncome'] != 'Yes') 
        this.invalidFields['busninessIncome'] = true

      if (this.data['busninessEmployees'] != 'No')
        this.invalidFields['busninessEmployees'] = true
    }

    if (this.data['crypto'] != 'No')
      this.invalidFields['crypto'] =  true

    if (this.data['householdPeople'] < 1 || this.data['householdPeople'] > 20) {
      this.invalidFields['householdPeople'] = true
    }
    if (this.data['dependents'] < 0 || this.data['dependents'] > 20) {
      this.invalidFields['dependents'] = true      
    }

    if (this.data['language'] == 'Other' && this.data['otherLanguage'] == '') {
      this.invalidFields['otherLanguage'] = true    
    }

    this.isFormValid = (Object.keys(this.invalidFields).length == 0)
    this.nextStepDisabled = this.isNextStepDisabled()
    console.log("!!!!!!validate()", this.invalidFields)
    return this.isFormValid
  }

  validateRequiredFields(): boolean {

    this.invalidFields = {}

    // check for any empty responses
    for (let field of this.requiredFields) {
      if (this.data[field] === '') {
        this.invalidFields[field] = true
      }
    }

    
    // if (this.appointmentPickerProperties.time === undefined)
    //   this.invalidFields['selectedTime'] = true
    
    if (this.appointmentPickerProperties.selectedTime === undefined)
      this.invalidFields['selectedTimeID'] = true

    if (this.appointmentPickerProperties.selectedDate === undefined)
      this.invalidFields['selectedDate'] = true

    if (this.appointmentPickerProperties.selectedSite === undefined)
      this.invalidFields['selectedSite'] = true

    // this.nextStepDisabled = this.isNextStepDisabled()
    console.log("!!!!!!validateRequiredFields()", this.invalidFields)
    return (Object.keys(this.invalidFields).length == 0)
  }

  nextStep() {
    if (this.currentStep < this.maxSteps) {
      var self = this
      this.currentStep += 1
      document.querySelectorAll(".step").forEach(el => {
          el.classList.remove('active'); 
          // make it so can't tab over
          el.setAttribute('inert', 'true')
        })
      setTimeout(() => {
        const e = document.querySelector<HTMLElement>(`:nth-child(${this.currentStep} of .step`);
        if (e) {
          self.currentStepName = e?.getAttribute('data-step') ?? 'resident'
          e.removeAttribute('inert')
          e.classList.add('active')
          document.querySelector('.steps')?.scrollTo({left: e.offsetLeft, behavior: self.scrollBehavior})
        }
        self.nextStepDisabled = self.isNextStepDisabled()
      }, 50)
    }
    this.validateRequiredFields()
    return false
  }
  previousStep() {
    if (this.currentStep > 1) {
      var self = this
      this.currentStep -= 1
      document.querySelectorAll(".step").forEach(el => {
          el.classList.remove('active'); 
          // make it so can't tab over
          el.setAttribute('inert', 'true')
        })
      setTimeout(() => {
        const e = document.querySelector<HTMLElement>(`:nth-child(${this.currentStep} of .step`);
        if (e) {
          self.currentStepName = e?.getAttribute('data-step') ?? 'resident'
          e.removeAttribute('inert')
          e.classList.add('active')
          document.querySelector('.steps')?.scrollTo({ left: e.offsetLeft, behavior: self.scrollBehavior})
        }
        self.nextStepDisabled = self.isNextStepDisabled()
      }, 50)
    }
    this.validateRequiredFields()
    return false
  }
  hasMissingContactInfo() {
    if ( this.data['firstName'] == '' ||
      this.data['lastName'] == '' ||
      this.data['email'] == '' ||
      this.data['phone'] == '' ||
      this.data['bestTimeToCall'] == '' ||
      this.data['language'] == '' 
    ) 
      return true
    return false
  }
  updateAppointmentData() {
    this.validate()
    setTimeout(() => {
      const step = document.querySelector('.step.active');
      step?.scrollTo({
        top: step.scrollHeight,
        behavior: 'instant'
      });
    }, 50);
  }
  isNextStepDisabled() {
    // nextStepDisabled
    console.log('nextStepDisabled this.currentStepName', this.currentStepName)
    if (this.currentStepName != 'resident') {
      return true;
    }
    return false;

    switch (this.currentStepName) {
      case 'appttype': 
        if (this.data['appttype'] == 'inperson') 
          return false
        return true
      break
      case 'resident': 
        if (this.data['resident'] == 'Yes') 
          return false
        return true
      break
  
      case 'OldReturn': 
        if (this.data['OldReturn'] == 'No')
          return false
        return true
      break
      case 'Amendment': 
        if (this.data['Amendment'] == 'Yes')
          return true
        return false
      break
      case 'crypto': 
        if (this.data['crypto'] == 'Yes')
          return true
        return false
      break
      case 'householdIncome': 
        if (this.data['householdIncome'] == '')
          return true
        return false
      break
      case 'selfEmployment': 
        if ((
          this.data['selfEmployment'] == '' 
            || this.data['selfEmployment'] == 'Yes' && (this.data['busninessIncome'] == '' || this.data['busninessIncome'] == 'No')
            || this.data['selfEmployment'] == 'Yes' && (this.data['busninessEmployees'] == '' || this.data['busninessEmployees'] == 'Yes')
          ))
            return true
        return false
      break
      case 'contactInfo': 
        if (this.hasMissingContactInfo())
          return true
        console.log("this.data['language']",this.data['language'])
        if (this.data['language'] == 'Other' && this.data['otherLanguage'] == ''
          || this.data['language'] == ''
        ) {
          return true
        }
        return false
      break
      case 'demographic': 
      console.log("nextStepDisabled")
        return false
      break
      case 'scheduler': 
        if (this.appointmentPickerProperties.selectedTime != null)
          return false
        return true
      break
      default: 
        console.error("could not find step in canNextStep:", this.currentStepName)
        return true // i guess?
    }
  }


  resendConfirmationEmail() {
    fetch("/api/resendEmailConfirmation/"+this.resendToken)
    .then(response => {
      console.log("resendConfirmationEmail success", response)
      this.resendTokenSent = true
      this.resendToken = ''
    })
   
    .catch(error => {
      console.error('resendConfirmationEmail error', error.message);
    });
  }
  answerDemographic(yesNo: boolean) {
    this.showDemographicFields = yesNo
  }
}
